import React from 'react';
import './videoSection.css';

const VideoSection: React.FC = () => {
  return (
    <div className="video-container">
      <a
        href="https://devpost.com/software/gender-inclusive-language-example"
        target="_blank"
        rel="noopener noreferrer"
        className="video-link"
      >
        Hackathon Link
      </a>
    </div>
  );
};

export default VideoSection;
